export default "__VITE_ASSET__CrCFBqYO__"